import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Constants } from '@sharedConstants/constants';
import { PimsUser } from '@shared/models/pims-user';
import { NatResponse } from '@sharedModels/http/nat-response';
import { AppContextService } from '@core/services/app-context.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  public currentUser: PimsUser;

  constructor(
    private http: HttpClient,
    private appContext: AppContextService
  ) { }

  loadCurrentUser = (): Promise<any> => {
    return this.http.get(
      this.appContext.commonApiUrl + '/GetCurrentUser',
      Constants.httpOptions
    )
      .toPromise()
      .then((response: NatResponse) => {
        this.currentUser = response.data;
      });
  }
}
